<template>
  <div :class="`${el}__step2`">
    <InViewAnimation>
      <Headline slot="1" size="xs" responsive noMargin centered>
        {{ $t('intro.step2.headline') }}
      </Headline>
      <Copy slot="2" element="div" :staticClass="`${el}__step2Copy`" centered>
        {{ $t('intro.step2.copy') }}
      </Copy>
      <Button
        slot="3"
        :class="`${el}__step2Button`"
        :href="href"
        :label="$t('intro.step2.button')"
        small
        @click="() => $emit('onTrackingClick', '_btn-' + $t('intro.step2.button'), 'button')"
      />
    </InViewAnimation>
  </div>
</template>

<script>
import Button from '@/objects/Button';
import Copy from '@/objects/Copy';
import Headline from '@/objects/Headline';
import InViewAnimation from '@/components/InViewAnimation';

export default {
  name: 'Step2',
  props: {
    el: String,
    href: String,
  },
  components: {
    Button,
    Copy,
    Headline,
    InViewAnimation,
  },
  data() {
    return {};
  },
};
</script>
